<template>

    <FormRow
        v-if="!readonly || valueData || forceShowWhenEmpty"
		:prop="prop"
		:propPrefix="propPrefix"
        :showHighlight="showHighlight"
		:labelMinWidth="labelMinWidth"
        :title="title"
        :tooltipText="tooltipText"
		:description="description"
		:tooltip-position="tooltipPosition"
        :isFocused="isFocusedData"
        :readonly="readonly"
		:isVertical="isVertical"
		:class="{'mb-3': !readonly && addBottomMargin}"
		:content-class="[$attrs.contentClass]"
        v-bind="attrsNoListeners"
        :disabled="disabled">

		<template v-if="$slots['title-postfix']" #title-postfix>
			<slot name="title-postfix"></slot>
		</template>
		<template v-if="$slots.tooltip" #tooltip>
			<slot name="tooltip"></slot>
		</template>

        <div>
<!--            <div :class="{'white-smoke': !readonly || !hideHighlight}">-->
<!--        <div class="white-smoke">-->

            <qw-input class=""
					  style="min-width: 150px;"
                      autocomplete="new-password"
                      v-model="valueData"
					  :inputDebounceDelay="inputDebounceDelay"
                      :readonly="readonly"
                      :type="wrapText || multiline ? 'textarea' : type"
                      :autosize="wrapText || multiline || minRows ? {minRows} : null"
                      :disabled="disabled"
                      :placeholder="placeholder"
					  :class="[textClass]"
                      v-bind="attrsNoListeners"
					  @change="notifyValueChangedFormTextRow"
                      @keydown.enter="onEnterPressed"
                      @focus="onFocus"
                      @blur="onBlur"/>
        </div>

        <!--		<template #tooltip>-->
        <!--			<slot name="tooltip"></slot>-->
        <!--		</template>-->
    </FormRow>

</template>

<script>

import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue"
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";

export default {
    name: "FormTextRow",
    components: {QwInput, FormRow},
    extends: BaseFormRow,

	inheritAttrs: false,

    props: {
		showHighlight: Boolean,
        type: String,
		labelMinWidth: Number,
		forceShowWhenEmpty: Boolean,
        multiline: {Boolean, default: false},
        preventEnterKey: {Boolean, default: false},
        wrapText: {Boolean, default: false},
        minRows: Number,
        textClass: String,
		tooltipPosition: String,
        inputAttrs: {Object, default: () => ({})},
        inputDebounceDelay: Number,
		disableDebounce: {Boolean, default: true},//debounce is handled by <qw-input/>
		disabled: Boolean,
		addBottomMargin: {Boolean, default: true},
		isVertical: Boolean,
    },

    methods: {
        onEnterPressed(event) {
            if (this.preventEnterKey || this.wrapText) {
                event.preventDefault()
            }
        },

        focus() {
			let input = this.$el.getElementsByTagName("textarea")[0]
			if(!input){
				input = this.$el.getElementsByTagName("input")[0]
			}
            input.focus()
        },

		notifyValueChangedFormTextRow(){
			this.notifyValueChanged()
		},

		insertTextAtCursor(text){
			let textArea = this.$el.getElementsByTagName("textarea")[0]
			if(!textArea){
				textArea = this.$el.getElementsByTagName("input")[0]
			}
			let caretPos = textArea.selectionStart;
			let textAreaTxt = textArea.value;
			this.valueData = textAreaTxt.substring(0, caretPos) + text + textAreaTxt.substring(caretPos)
			this.notifyValueChanged()
		}
    },

    computed: {
        inputAttrsComputed() {
            return {
                ...this.$attrs,
                ...this.inputAttrs
            }
        }
    }
}
</script>

<style>
.bold2 {
    font-weight: 600;
}

</style>
